import gql from 'graphql-tag';

import { FEED_ANSWER_FRAGMENT } from './feedAnswer';

export const FEED_QUESTION_DETAILS_FRAGMENT = gql`
  fragment feedQuestionDetails on Question {
    id
    author {
      id
      name
      email
      picture
      jobTitle
    }
    boardId
    type
    text
    createdAt
    publishChangedAt
    commentsCount
    positionInBoard {
      id
      positionInBoard
    }
    acceptedAnswer {
      ...feedAnswer
    }
    answersCount
    labels {
      id
      name
    }
    status
    notification {
      id
      isRead
    }
    currentUserReactions
    currentUserRelation
    watching
    permalink
    deleted
  }

  ${FEED_ANSWER_FRAGMENT}
`;
